import store from "@/stores/store";
import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import documents from "./submodules/documents";
import invoiceitems from "./submodules/invoiceitems";
import qs from "qs";
import $utils from '@/utils';
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';

const { getStorageKey } = utils;

const state = {
    is_receipt_operator: false,

    receipt: null,
    receipt_loading: false,
    receipt_loading_errors: null,
    receipt_saving: false,
    receipt_saving_errors: null,
    receipt_deleting: false,
    receipt_deleting_errors: null,

    receiptitem: null,
    receiptitem_loading: false,
    receiptitem_loading_errors: null,
    receiptitem_saving: false,
    receiptitem_saving_errors: null,
    receiptitem_deleting: false,
    receiptitem_deleting_errors: null,

    receiptitems: [],
    receiptitems_filters: { limit: 20 },
    receiptitems_count: 0,
    receiptitems_loaded: false,
    receiptitems_loading: false,
    receiptitems_loading_errors: null,
    receiptitems_cancel_source: null,

    providers: [],
    providers_count: 0,
    providers_loading: false,
    providers_loading_errors: null,

    stocks: [],
    stocks_count: 0,
    stocks_loading: false,
    stocks_loading_errors: null,

    products: [],
    products_filters: { offset: 0, limit: 20 },
    products_count: 0,
    products_loading: false,
    products_loading_errors: null,
    products_cancel_source: null,

    setting_readyness: false,
    completing_receipt: false,
    cancelling_receipt: false,
    placing_receipt: false,
    assigning_receipt: false,
    providerstats: null,

    events: [],
    events_filters: { offset: 0, limit: 20 },
    events_loading: false,
    events_loading_errors: null,
    events_count: 0,

    receipt_stats: {},
    receipt_stats_loading: false,
    receipt_stats_loading_errors: null,
    receipt_stats_loaded: false,

    productstrategy: [],
    productstrategy_loading: false,

    creating_providerorder: false,
};

let getProductsFilters = function (state, receipt) {
    if (!receipt) {
        return { limit: state.products_filters.limit || 20 };
    }
    const base = {
        offset: 0,
        limit: state.products_filters.limit || 20,
        stock: receipt.stock,
        include_archived: false,
        exclude_receipt_products: receipt.receipt_id,
    };
    if (receipt.provider) {
        return { ...base, provider: receipt.provider };
    }
    return { ...base, stock_owner: "entity" };
};

const usesProviderProductInventory = (receipt) =>
    Boolean(receipt?.provider && receipt?.stock_owner === "provider");

const mutations = {
    updateIsReceiptOperator(state, is_receipt_operator) {
        state.is_receipt_operator = is_receipt_operator;
    },

    updateReceipt(state, receipt) {
        if (receipt && state.receipt && state.receipt.receipt_id == receipt.receipt_id) {
            state.receipt = receipt;
            return;
        }

        state.receipt = receipt;
        state.providerstats = null;
        state.products = [];
        state.products_count = 0;

        state.receiptitems = [];
        state.receiptitems_count = 0;
        state.receiptitems_loaded = false;

        state.productstrategy = [];
        state.productstrategy_loading = false;

        state.events = [];
        state.events_count = 0;
        state.events_loading = false;
        state.events_loading_errors = null;

        if (!state.receipt) {
            state.products_filters = { limit: state.products_filters.limit };
            state.receiptitems_filters = { limit: state.receiptitems_filters.limit };
            state.events_filters = {};
            return;
        }

        state.products_filters = getProductsFilters(state, receipt);

        state.receiptitems_filters = {
            limit: state.receiptitems_filters.limit || 20,
            receipt: receipt.receipt_id,
            stock: receipt.stock,
        };

        state.events_filters = {
            ordering: "-event_date",
            object_id: receipt.receipt_id,
            object_type: "receipt",
        };
    },
    updateReceiptLoading(state, loading) {
        state.receipt_loading = loading;
    },
    updateReceiptLoadingErrors(state, errors) {
        state.receipt_loading_errors = errors;
    },
    updateReceiptSaving(state, saving) {
        state.receipt_saving = saving;
    },
    updateReceiptSavingErrors(state, errors) {
        state.receipt_saving_errors = errors;
    },
    updateReceiptDeleting(state, deleting) {
        state.receipt_deleting = deleting;
    },
    updateReceiptDeletingErrors(state, errors) {
        state.receipt_deleting_errors = errors;
    },

    updateProviders(state, providers) {
        state.providers = providers;
    },
    updateProvidersLoading(state, loading) {
        state.providers_loading = loading;
    },
    updateProvidersLoadingErrors(state, errors) {
        state.providers_loading_errors = errors;
    },
    updateProvidersCount(state, count) {
        state.providers_count = count;
    },

    updateStocks(state, stocks) {
        state.stocks = stocks;
    },
    updateStocksLoading(state, loading) {
        state.stocks_loading = loading;
    },
    updateStocksLoadingErrors(state, errors) {
        state.stocks_loading_errors = errors;
    },
    updateStocksCount(state, count) {
        state.stocks_count = count;
    },

    updateReceiptItem(state, receiptitem) {
        state.receiptitem = receiptitem;
    },
    updateReceiptItemLoading(state, loading) {
        state.receiptitem_loading = loading;
    },
    updateReceiptItemLoadingErrors(state, errors) {
        state.receiptitem_loading_errors = errors;
    },
    updateReceiptItemSaving(state, saving) {
        state.receiptitem_saving = saving;
    },
    updateReceiptItemSavingErrors(state, errors) {
        state.receiptitem_saving_errors = errors;
    },
    updateReceiptItemDeleting(state, deleting) {
        state.receiptitem_deleting = deleting;
    },
    updateReceiptItemDeletingErrors(state, errors) {
        state.receiptitem_deleting_errors = errors;
    },

    updateReceiptItems(state, receiptitems) {
        state.receiptitems = receiptitems;
        state.receiptitems_loaded = true;
    },
    updateReceiptItemsFilters(state, filters) {
        state.receiptitems_filters = {
            receipt: state.receipt ? state.receipt.receipt_id : null,
            limit: state.receiptitems_filters.limit || 20,
            ...filters,
        };
    },
    updateReceiptItemsCount(state, count) {
        state.receiptitems_count = count;
    },
    updateReceiptItemsLoading(state, loading) {
        state.receiptitems_loading = loading;
    },
    updateReceiptItemsLoadingErrors(state, errors) {
        state.receiptitems_loading_errors = errors;
    },

    updateReceiptItemsCancelSource(state, source) {
        state.receiptitems_cancel_source = source;
    },

    updateProducts(state, products) {
        state.products = products;
    },
    updateProductsCount(state, products_count) {
        state.products_count = products_count;
    },
    updateProductsFilters(state, filters) {
        state.products_filters = Object.assign(
            getProductsFilters(state, state.receipt),
            filters
        );
    },
    updateProductsLoading(state, loading) {
        state.products_loading = loading;
    },
    updateProductsLoadingErrors(state, errors) {
        state.products_loading_errors = errors;
    },
    updateProductsCancelSource(state, source) {
        state.products_cancel_source = source;
    },

    updateSynchronizingProducts(state, synchronizing) {
        state.synchronizing_products = synchronizing;
    },
    updateSynchronizingProductsErrors(state, errors) {
        state.synchronizing_products_errors = errors;
    },

    updateProviderStats(state, providerstats) {
        state.providerstats = providerstats;
    },
    updateCompletingReceipt(state, completing_receipt) {
        state.completing_receipt = completing_receipt;
    },
    updateCancellingReceipt(state, cancelling_receipt) {
        state.cancelling_receipt = cancelling_receipt;
    },
    updateSettingReadyness(state, setting_readyness) {
        state.setting_readyness = setting_readyness;
    },
    updatePlacingReceipt(state, placing_receipt) {
        state.placing_receipt = placing_receipt;
    },
    updateAssigningReceipt(state, assigning_receipt) {
        state.assigning_receipt = assigning_receipt;
    },

    updateEvents(state, data) {
        state.events = data.results;
        state.events_count = data.count;
    },
    updateEventsLoading(state, events_loading) {
        state.events_loading = events_loading;
    },
    updateEventsLoadingErrors(state, events_loading_errors) {
        state.events_loading_errors = events_loading_errors;
    },

    updateReceiptStats(state, receipt_stats) {
        state.receipt_stats = receipt_stats;
    },
    updateReceiptStatsLoading(state, loading) {
        state.receipt_stats_loading = loading;
    },
    updateReceiptStatsLoadingErrors(state, errors) {
        state.receipt_stats_loading_errors = errors;
    },
    updateReceiptStatsLoaded(state, loaded) {
        state.receipt_stats_loaded = loaded;
    },

    updateProductStrategy(state, productstrategy) {
        state.productstrategy = productstrategy;
    },
    updateProductStrategyLoading(state, productstrategy_loading) {
        state.productstrategy_loading = productstrategy_loading;
    },
    updateCreatingProviderOrder(state, creating_providerorder) {
        state.creating_providerorder = creating_providerorder;
    },
};

const getters = {
    usesProviderProductInventory(state) {
        return usesProviderProductInventory(state.receipt);
    },
    productStrategyNeedsUserInput(state) {
        if (usesProviderProductInventory(state.receipt)) {
            return false;
        }
        return state.productstrategy.some((product) => !product.target_product);
    },
};

const actions = {
    async fetchProductStrategy({ commit, state }) {
        if (store.getters["session/current_entity_profile"] == "operator") {
            return [];
        }
        if (usesProviderProductInventory(state.receipt)) {
            commit("updateProductStrategy", []);
            return [];
        }
        commit("updateProductStrategy", []);
        commit("updateProductStrategyLoading", true);

        try {
            let response = await axios.get(
                `/api/receipts/${state.receipt.receipt_id}/productstrategy/`
            );
            commit("updateProductStrategy", response.data.products);
            return response.data.products;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateProductStrategyLoading", false);
        }
    },

    async fetchEvents({ commit, dispatch, state }, params) {

        if (!state.events_filters) return;
        commit("updateEventsLoading", true);
        try {
            const response = await axios.get("/api/events/", { params: state.events_filters });
            commit("updateEvents", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateEventsLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateEventsLoading", false);
        }
    },

    update({ commit, dispatch, state }, params) {
        dispatch("fetchReceipt");
        dispatch("fetchReceiptStats");
        dispatch("fetchEvents");
        dispatch("session/fetchStats", null, { root: true });
        let is_receipt_operator =
            state.receipt?.operator == store.getters["session/current_entity_id"];

        if (is_receipt_operator && state.receipt.ready) {
            dispatch("fetchReceiptItems");
        } else {
            dispatch("fetchProducts");
            dispatch("fetchReceiptItems");
            if (!usesProviderProductInventory(state.receipt)) {
                dispatch("fetchProductStrategy");
            }
        }
        dispatch("invoiceitems/fetchInvoiceItems");
        dispatch("documents/fetchDocuments");
        dispatch("fetchProviderStats");
    },

    init({ commit, dispatch, state }, params) {
        dispatch("invoiceitems/init", {
            shipment: params.receipt,
            url: `/api/receipts/${params.receipt.receipt_id}/invoiceitems/`,
        });
        let shared_with = null;
        if (store.getters["session/current_entity_id"] !== params.receipt.owner) {
            shared_with = params.receipt.owner;
        }

        dispatch("documents/init", {
            tags: `receipt:${params.receipt.receipt_id}`,
            shared_with: shared_with,
            create_tags: [
                `receipt:${params.receipt.receipt_id}`,
                `provider:${params.receipt.provider}`,
            ],
        });
        commit("updateReceipt", params.receipt);

        dispatch("fetchReceiptStats");
        dispatch("session/fetchStats", null, { root: true });
        let is_receipt_operator =
            params.receipt.operator == store.getters["session/current_entity_id"];
        commit("updateIsReceiptOperator", is_receipt_operator);
        if (is_receipt_operator && params.receipt.ready) {
            dispatch("fetchReceiptItems");
        } else {
            dispatch("fetchProducts");
            dispatch("fetchReceiptItems");
        }
        dispatch("fetchEvents");
        dispatch("invoiceitems/fetchInvoiceItems");
        dispatch("documents/fetchDocuments");
        dispatch("fetchProviderStats");
        if (!usesProviderProductInventory(params.receipt)) {
            dispatch("fetchProductStrategy");
        }
    },
    async createProviderOrder({ commit, dispatch, state }, params) {
        try {
            commit("updateCreatingProviderOrder", true);
            const response = await axios.post(
                `/api/receipts/${state.receipt.receipt_id}/providerorder/`
            );
            return response.data;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateCreatingProviderOrder", false);
        }
    },

    async fetchReceipt({ commit, dispatch, state }, params) {
        commit("updateReceiptLoading", true);
        commit("updateReceiptLoadingErrors", null);

        let url;
        if (params && params.receipt_id) {
            url = `/api/receipts/${params.receipt_id}/`;
        } else if (state.receipt) {
            url = `/api/receipts/${state.receipt.receipt_id}/`;
        } else {
            return;
        }
        try {
            const response = await axios.get(url);
            commit("updateReceipt", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateReceiptLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateReceiptLoading", false);
            dispatch("fetchReceiptStats");
            dispatch("fetchProducts");
            dispatch("fetchReceiptItems");
            dispatch("fetchEvents");
            dispatch("invoiceitems/fetchInvoiceItems");
            dispatch("documents/fetchDocuments");
            dispatch("fetchProviderStats");
        }
    },

    async deleteReceipt({ commit, dispatch, state }, params) {
        commit("updateReceiptDeleting", true);
        commit("updateReceiptDeletingErrors", null);

        const url = `/api/receipts/${params.instance.receipt_id}/`;
        try {
            const response = await axios.delete(url);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateReceiptDeletingErrors", error.details);
            throw error;
        } finally {
            commit("updateReceiptDeleting", false);
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async archiveReceipt({ dispatch, state }, params) {
        const receiptId = params?.instance?.receipt_id || state.receipt?.receipt_id;
        try {
            const response = await axios.post(`/api/receipts/${receiptId}/archive/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch("fetchReceipt");
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async unarchiveReceipt({ dispatch, state }, params) {
        const receiptId = params?.instance?.receipt_id || state.receipt?.receipt_id;
        try {
            const response = await axios.post(`/api/receipts/${receiptId}/unarchive/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch("fetchReceipt");
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async deleteReceiptItem({ commit, dispatch, state }, params) {
        commit("updateReceiptItemDeleting", true);
        commit("updateReceiptItemDeletingErrors", null);

        const url = `/api/receiptitems/${params.instance.id}/`;
        try {
            const response = await axios.delete(url);
            dispatch("fetchReceipt");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateReceiptItemDeletingErrors", error.details);
            throw error;
        } finally {
            commit("updateReceiptItemDeleting", false);
        }
    },

    async saveReceipt({ commit, dispatch, state }, params) {
        commit("updateReceiptSaving", true);
        commit("updateReceiptSavingErrors", null);

        let url = "/api/receipts/";
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/receipts/${params.instance.receipt_id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            dispatch("fetchReceipt");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateReceiptSavingErrors", error.details);
            throw error;
        } finally {
            commit("updateReceiptSaving", false);
        }
    },

    async setReceiptReadyness({ commit, dispatch, state }, params) {
        const url = `/api/receipts/${params.receipt.receipt_id}/ready/`;
        commit("updateSettingReadyness", true);
        try {
            const payload = { ready: params.ready };
            if (params.productstrategy != null) {
                payload.productstrategy = params.productstrategy;
            }
            const response = await axios.put(url, payload);
            dispatch("fetchReceipt");
            return response.data;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateSettingReadyness", false);
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async placeReceipt({ commit, dispatch, state }, params) {
        const url = `/api/receipts/${state.receipt.receipt_id}/place/`;
        commit("updatePlacingReceipt", true);
        try {
            const response = await axios.put(url);
            dispatch("fetchReceipt");
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updatePlacingReceipt", false);
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async assignReceipt({ commit, dispatch, state }, params) {
        const url = `/api/receipts/${state.receipt.receipt_id}/assign/`;
        commit("updateAssigningReceipt", true);
        try {
            const response = await axios.put(url, { user: params.user });
            dispatch("fetchReceipt");
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateAssigningReceipt", false);
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async cancelReceipt({ commit, dispatch, state, rootState }, params) {
        const url = `/api/receipts/${state.receipt.receipt_id}/cancel/`;
        try {
            commit("updateCancellingReceipt", true);
            const response = await axios.post(url);
            await dispatch("fetchReceipt");
            const providerOrderId = state.receipt?.providerorder;
            const loadedProviderOrder = rootState.providerorder?.providerorder;
            if (
                providerOrderId &&
                loadedProviderOrder?.id === providerOrderId
            ) {
                await dispatch("providerorder/fetchProviderOrder", null, { root: true });
                dispatch("providerorder/fetchReceipts", null, { root: true });
            }
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateCancellingReceipt", false);
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async completeReceipt({ commit, dispatch, state }, params) {
        const url = `/api/receipts/${state.receipt.receipt_id}/complete/`;
        commit("updateCompletingReceipt", true);
        try {
            const response = await axios.put(url, params || {});
            dispatch("fetchReceipt");
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateCompletingReceipt", false);
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async setReceiptItemStatus({ commit, dispatch, state }, params) {
        const data = {
            status: params.status,
        };
        try {
            const response = await axios.put(`/api/receiptitems/${params.receiptitem.id}/status/`, data);
            dispatch("fetchReceipt");
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch("fetchEvents");
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async fetchProviderStats({ commit, dispatch, state }, params) {
        if (!state.receipt.provider) {
            return;
        }

        if (
            state.receipt.provider_data.owner !=
            store.getters["session/current_entity_id"]
        ) {
            return;
        }
        try {
            const response = await axios.get(`/api/providers/${state.receipt.provider}/stats/`);
            commit("updateProviderStats", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async fetchReceiptItems({ commit, state }) {
        commit("updateReceiptItemsLoading", true);
        commit("updateReceiptItemsLoadingErrors", null);

        if (state.receiptitems_cancel_source) {
            state.receiptitems_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateReceiptItemsCancelSource", cancelSource);

        try {
            const response = await axios.get("/api/receiptitems/", {
                params: state.receiptitems_filters,
                cancelToken: state.receiptitems_cancel_source?.token,
            });
            commit("updateReceiptItems", response.data.results);
            commit("updateReceiptItemsCount", response.data.count);
            commit("updateReceiptItemsCancelSource", null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit("updateReceiptItemsLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateReceiptItemsLoading", false);
        }
    },

    async fetchProducts({ commit, dispatch, state }, params) {
        commit("updateProductsLoading", true);
        commit("updateProductsLoadingErrors", null);

        if (state.products_cancel_source) {
            state.products_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateProductsCancelSource", cancelSource);
        let url = "/api/products/";
        if (state.receipt.provider) {
            url = `/api/providerproducts/`;
        }
        try {
            const response = await axios.get(url, {
                params: state.products_filters,
                cancelToken: state.products_cancel_source?.token,
            });
            commit("updateProducts", response.data.results);
            commit("updateProductsCount", response.data.count);
            commit("updateProductsCancelSource", null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            let error = utils.handleError(xhr_error);
            commit("updateProductsCancelSource", null);
            commit("updateProductsLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateProductsLoading", false);
        }
    },

    async fetchReceiptStats({ commit, dispatch, state }, params) {
        commit("updateReceiptStatsLoading", true);
        commit("updateReceiptStatsLoadingErrors", null);
        try {
            const response = await axios.get(
                `/api/receipts/${state.receipt.receipt_id}/stats/`
            );
            commit("updateReceiptStats", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateReceiptStatsLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateReceiptStatsLoading", false);
        }
    },

    exportReceiptItemsAsCSV({ commit, dispatch, state }, params) {
        let filters = {
            format: "csv",
            limit: CSV_EXPORT_LIMIT,
            receipt: state.receipt.receipt_id,
        };
        
        const receiptId = state.receipt?.receipt_id || state.receipt?.id || '';
        
        $utils.downloadFile({
            url: "/api/receiptitems/",
            params: filters,
        }, $utils.getFilename('receiptItems', { receipt_id: receiptId }));
    },

    async duplicateReceipt({ commit, dispatch, state }, params) {
        try {
            const url = `/api/receipts/${state.receipt.id}/duplicate/`;
            const response = await axios.post(url);
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            return Promise.reject(utils.handleError(xhr_error));
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    modules: {
        documents: documents({
            storageKey: getStorageKey('receipt', 'documents'),
            fieldsToSave: ['limit', 'ordering']
        }),
        invoiceitems: invoiceitems({
            storageKey: getStorageKey('receipt', 'invoiceitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
    },
};
